// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ControlTwoToneSvg from "@ant-design/icons-svg/es/asn/ControlTwoTone";
import AntdIcon from '../components/AntdIcon';

var ControlTwoTone = function ControlTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ControlTwoToneSvg
  }));
};

ControlTwoTone.displayName = 'ControlTwoTone';
export default React.forwardRef(ControlTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ControlTwoTone.js
// module id = 867
// module chunks = 0